function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Icon_ionic-ios-close-circle",
  d: "M15.239,3.375A11.864,11.864,0,1,0,27.1,15.239,11.862,11.862,0,0,0,15.239,3.375Zm3.006,16.159-3.006-3.006-3.006,3.006a.912.912,0,1,1-1.289-1.289l3.006-3.006-3.006-3.006a.912.912,0,1,1,1.289-1.289l3.006,3.006,3.006-3.006a.912.912,0,1,1,1.289,1.289l-3.006,3.006,3.006,3.006a.916.916,0,0,1,0,1.289A.905.905,0,0,1,18.245,19.534Z",
  transform: "translate(-3.375 -3.375)"
});

function SvgWrongErrorFilled2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "red",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.728,
    height: 23.728,
    viewBox: "0 0 23.728 23.728",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrongErrorFilled2);
export default __webpack_public_path__ + "static/media/wrong_error_filled_2.1ddedc1e.svg";
export { ForwardRef as ReactComponent };